module.exports = __webpack_public_path__ + "b5fccd9234d20b11e7d4b100af67f256.svg";